import React from "react";
import { Route, Redirect } from "react-router-dom";

const Authenticated = ({ authenticated, loggingIn, component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => {
        if (loggingIn) {
          return <div> </div>;
        }
        if (authenticated) {
          return React.createElement(component, {
            ...props,
            loggingIn,
            authenticated
          });
        } else {
          return <Redirect to="/signin" />;
        }
      }}
    />
  );
};

export default Authenticated;



// WEBPACK FOOTER //
// ./src/components/Authenticated.js